import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const Performance = React.forwardRef((props, ref) => {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M20.125 2.625H3.875C3.18464 2.625 2.625 3.18464 2.625 3.875V20.125C2.625 20.8154 3.18464 21.375 3.875 21.375H20.125C20.8154 21.375 21.375 20.8154 21.375 20.125V3.875C21.375 3.18464 20.8154 2.625 20.125 2.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8982 9.5L12.4661 14.4383L9.50308 11.6728L5.75 14.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8984 12.6605V9.5H14.6392"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
